import React, { useEffect } from "react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Box } from "@mui/material";
import { PACKAGE_TYPES, STATUS_OPTIONS } from "../../utils/constant";
import {
  createLiveFreeChannel,
  createPackage,
  getallChannel,
  getAllChannelCategory,
  getAllChannelLanguage,
  updateLiveFreeChannel,
  updatePackage,
} from "../../Components/service/admin";

import { loader, snackbar } from "../../utils";
import EditIcon from "@mui/icons-material/Edit";
import CustomDrawer from "../../Components/CustomDrawer/CustomDrawer";
import { AutoComplete } from "../../Components/Inputs/AutoComplete";

export const AddFreeLiveChannel = ({ onSubmit, mode, formData }) => {
  // console.log(formData, " this is the form Data");
  let [drawer, setDrawer] = useState(false);
  let [allChannels, setAllChannels] = useState([]);
  const [allChannelCategory, setAllChannelCategory] = useState([]);
  const [language, setAllLanguage] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      channelUrl: "",
      channelCategory: null,
      priority: "",
      image: null,
      channelNumber: "",
      language: "",
      status: true,
      //   selected_channels: [],
    },
  });

  useEffect(() => {
    if (drawer) {
      getAllChannel();
      getAllCategoryChannel();
      getAllLanguage();
    }
  }, [drawer]);

  async function getAllChannel() {
    try {
      let res = await getallChannel();
      // console.log(res.data.data);
      setAllChannels(res?.data?.data || []);
    } catch (error) {
      console.log(error);
      const errorMessage =
        error?.response?.data?.errormessage ||
        error?.message ||
        "Failed to fetch channels";
      snackbar.error(errorMessage);
    }
  }

  async function getAllLanguage() {
    try {
      let res = await getAllChannelLanguage();
      setAllLanguage(res?.data?.data || []);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errormessage ||
        error?.message ||
        "Failed to fetch languages";
      snackbar.error(errorMessage);
    }
  }

  async function formSubmit(data) {
    // console.log(data, " this is the data");
    try {
      loader.start();
      const formDatas = new FormData();
      formDatas.append("name", data.name);
      formDatas.append("status", data.status);
      formDatas.append("channelUrl", data.channelUrl);
      formDatas.append("channelCategory", data.channelCategory);
      formDatas.append("priority", data.priority);
      formDatas.append("channelNumber", data.channelNumber);
      formDatas.append("language", data.language);
      // Only append image file if a new image is selected
      if (data.image && data.image instanceof File) {
        formDatas.append("image", data.image);
      }

      if (mode === "edit") {
        let res = await updateLiveFreeChannel(formData._id, formDatas);
        snackbar.success("LiveFreeChannel updated successfully");
      } else {
        let res = await createLiveFreeChannel(formDatas);
        snackbar.success("LiveFreeChannel created successfully");
      }
      onSubmit();
      reset({
        name: "",
        status: true,
        channelUrl: "",
        channelCategory: null,
        priority: "",
        image: null,
        channelNumber: "",
        language: "",
      });
      setImagePreview(null);
      setDrawer(false);
    } catch (error) {
      console.log(error);
      const errorMessage =
        error?.response?.data?.errormessage ||
        error?.message ||
        (mode === "edit"
          ? "Failed to update LiveFreeChannel"
          : "Failed to create LiveFreeChannel");
      snackbar.error(errorMessage);
    } finally {
      loader.stop();
    }
  }

  function editClick() {
    // console.log(formData);

    let {
      name,
      channelUrl,
      channelCategory,
      priority,
      image,
      channelNumber,
      language,
      status,
      //   selected_channels,
    } = formData;

    //  this is for set the id
    channelCategory = channelCategory?._id;

    // Set image preview for edit mode
    setImagePreview(image);

    reset({
      name,
      channelUrl,
      channelCategory,
      priority,
      image,
      channelNumber,
      language,
      status: status !== undefined ? status : true,
      //   selected_channels: selected_channels.map((e) => e.channel_id),
    });
    setDrawer(true);
  }

  // Handle image file selection and preview
  const handleImageChange = (file, onChange) => {
    // Clean up previous preview URL to prevent memory leaks
    if (imagePreview && imagePreview.startsWith("blob:")) {
      URL.revokeObjectURL(imagePreview);
    }

    onChange(file);
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    } else {
      setImagePreview(null);
    }
  };

  // Reset image preview when drawer closes
  const handleDrawerClose = () => {
    // Clean up preview URL to prevent memory leaks
    if (imagePreview && imagePreview.startsWith("blob:")) {
      URL.revokeObjectURL(imagePreview);
    }
    setDrawer(false);
    setImagePreview(null);
  };

  // Handle opening drawer for add mode
  const handleAddClick = () => {
    setImagePreview(null);
    setDrawer(true);
  };

  //  listing of channel Category

  // Fetch all packages
  async function getAllCategoryChannel() {
    try {
      loader.start();
      let res = await getAllChannelCategory();
      setAllChannelCategory(res?.data?.data || []);
    } catch (error) {
      console.log(error);
      const errorMessage =
        error?.response?.data?.errormessage ||
        error?.message ||
        "Failed to fetch channel categories";
      snackbar.error(errorMessage);
    } finally {
      loader.stop();
    }
  }

  // useEffect(() => {
  //   getAllCategoryChannel();
  // }, []);

  return (
    <div>
      {mode === "edit" ? (
        <EditIcon className="pointer" onClick={editClick} />
      ) : (
        <button
          className="btn btn-primary btn-radius px-3"
          onClick={handleAddClick}
        >
          Add Free Live Channel
        </button>
      )}
      <CustomDrawer
        width={600}
        open={drawer}
        toggle={handleDrawerClose}
        header={`${mode == "edit" ? "Edit" : "Add"} Package`}
      >
        <Box mt={3}>
          <form onSubmit={handleSubmit(formSubmit)}>
            <div>
              <label className="form-label mb-1" htmlFor="image">
                Free Live Channel Image
              </label>
              <Controller
                name="image"
                control={control}
                rules={{
                  required: mode === "edit" ? false : "Image is required",
                }}
                render={({ field: { onChange, value } }) => (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      id="image"
                      name="image"
                      onChange={(e) =>
                        handleImageChange(e.target.files[0], onChange)
                      }
                      className={`form-control ${
                        errors.image ? "Validation" : ""
                      }`}
                    />
                    {/* Image Preview */}
                    {imagePreview && (
                      <div className="mt-2">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{
                            width: "150px",
                            height: "150px",
                            objectFit: "cover",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              />
              {errors.image && (
                <p className="text-danger">{errors.image.message}</p>
              )}
            </div>

            {/* {errors.image && <p>{errors.image.message}</p>} */}

            <div>
              <label className="form-label mb-1" htmlFor="name">
                Free Live Channel Name
              </label>
              <Controller
                name="name"
                control={control}
                rules={{
                  required: "Required",
                  validate: (value) =>
                    value.trim() !== "" || "Field cannot be empty",
                }}
                defaultValue={null}
                render={({ field: { value, onChange } }) => {
                  return (
                    <input
                      value={value}
                      onChange={onChange}
                      className={`form-control ${
                        errors.name ? "Validation" : ""
                      }`}
                      placeholder="free channel Name"
                    />
                  );
                }}
              />
            </div>
            <div className="mt-3">
              <label className="form-label mb-1" htmlFor="status">
                Status
              </label>
              <Controller
                name="status"
                control={control}
                rules={{
                  required: false,
                  validate: (value) =>
                    typeof value === "boolean" || "Please select a status",
                }}
                render={({ field: { value, onChange } }) => {
                  return (
                    <select
                      className={`form-select ${
                        errors.status ? "Validation" : ""
                      }`}
                      value={value.toString()}
                      onChange={(e) => onChange(e.target.value === "true")}
                    >
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                    </select>
                  );
                }}
              />
              {errors.status && (
                <p className="text-danger">{errors.status.message}</p>
              )}
            </div>
            <div className="mt-3">
              <label className="form-label mb-1" htmlFor="name">
                Channel Categroy Name
              </label>
              <Controller
                name="channelCategory"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                render={({ field: { value, onChange } }) => {
                  return (
                    <select
                      className={`form-select ${
                        errors.channelCategory ? "Validation" : ""
                      }`}
                      value={value}
                      onChange={onChange}
                    >
                      <option value={""}>Select Channel Category</option>
                      {allChannelCategory.map((res) => {
                        return (
                          <option value={res._id} key={res._id}>
                            {res.name}
                          </option>
                        );
                      })}
                    </select>
                  );
                }}
              />
            </div>
            <div className="mt-3">
              <label className="form-label mb-1" htmlFor="name">
                Channel Language
              </label>
              <Controller
                name="language"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                render={({ field: { value, onChange } }) => {
                  return (
                    <select
                      className={`form-select ${
                        errors.language ? "Validation" : ""
                      }`}
                      value={value}
                      onChange={onChange}
                    >
                      <option value={""}>Select channel Language</option>
                      {language.map((res) => {
                        return (
                          <option value={res._id} key={res._id}>
                            {res.englishName}
                          </option>
                        );
                      })}
                    </select>
                  );
                }}
              />
            </div>
            <div className="mt-3">
              <label className="form-label mb-1" htmlFor="name">
                Channel Url
              </label>
              <Controller
                name="channelUrl"
                control={control}
                rules={{ required: true }}
                defaultValue={null}
                render={({ field: { value, onChange } }) => {
                  return (
                    <input
                      value={value}
                      type="text"
                      onChange={onChange}
                      className={`form-control ${
                        errors.channelUrl ? "Validation" : ""
                      }`}
                      placeholder="channel url"
                    />
                  );
                }}
              />
            </div>
            <div className="mt-3">
              <label className="form-label mb-1" htmlFor="name">
                ChannelNumber
              </label>
              <Controller
                name="channelNumber"
                control={control}
                rules={{ required: true }}
                defaultValue={null}
                render={({ field: { value, onChange } }) => {
                  return (
                    <input
                      value={value}
                      type="text"
                      onChange={onChange}
                      className={`form-control ${
                        errors.channelNumber ? "Validation" : ""
                      }`}
                      placeholder="Channel Number"
                    />
                  );
                }}
              />
            </div>
            {/* <div className="mt-3">
              <label className="form-label mb-1" htmlFor="name">
                Image Url
              </label>
              <Controller
                name="image"
                control={control}
                rules={{ required: true }}
                defaultValue={null}
                render={({ field: { value, onChange } }) => {
                  return (
                    <input
                      value={value}
                      type="text"
                      onChange={onChange}
                      className={`form-control ${
                        errors.channelUrl ? "Validation" : ""
                      }`}
                      placeholder="image url"
                    />
                  );
                }}
              />
            </div> */}
            <div className="mt-3">
              <label className="form-label mb-1" htmlFor="name">
                Priority
              </label>
              <Controller
                name="priority"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                render={({ field: { value, onChange } }) => {
                  return (
                    <input
                      value={value}
                      type="number"
                      className={`form-control ${
                        errors.priority ? "Validation" : ""
                      }`}
                      onChange={onChange}
                      placeholder="priority"
                    />
                  );
                }}
              />
            </div>
            {/* <div className="mt-3">
              <label className="form-label mb-1" htmlFor="name">
                Channels
              </label>
              <Controller
                name="selected_channels"
                control={control}
                rules={{ required: true }}
                defaultValue={null}
                render={({ field: { value, onChange } }) => {
                  return (
                    <AutoComplete
                      label={"Select Channel"}
                      multiple
                      error={errors.selected_channels}
                      className="bg-white"
                      disableCloseOnSelect
                      getOptionLabel={(option) => option?.name}
                      renderOption={(props, option, { selected }) => {
                        console.log(option);
                        return (
                          <li {...props}>
                            <input
                              type="checkbox"
                              className="me-6"
                              checked={value.includes(option._id)}
                              style={{ marginRight: 8 }}
                            />
                            {option?.name}
                          </li>
                        );
                      }}
                      renderTags={(tagValue, getTagProps) => (
                        <span className={`autocomplete-wrapper`}>
                          {tagValue.map((option) => option.name).join(" / ")}
                        </span>
                      )}
                      options={allChannels}
                      onChange={(e, val) => {
                        console.log(val);
                        onChange(val.map((e) => e._id));
                      }}
                      value={allChannels.filter((e) => value.includes(e._id))}
                    />
                  );
                }}
              />
            </div> */}
            <div className="d-flex justify-content-end mt-3">
              <button
                className="cancelButton border-none outline-none"
                type="button"
                onClick={handleDrawerClose}
              >
                Cancel
              </button>
              <button className="btn btn-primary m-1" type="submit">
                {mode == "edit" ? "Update" : "Add"} Free Channel
              </button>
            </div>
          </form>
        </Box>
      </CustomDrawer>
    </div>
  );
};
